var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _c(
        "v-col",
        {
          staticClass: "ma-0 pa-0 pl-5 pr-5 mb-2",
          staticStyle: { "font-weight": "bold" },
          attrs: { cols: "12", align: "left" },
        },
        [_vm._v(" " + _vm._s(_vm.t("all")) + " ")]
      ),
      _vm.fetchLoading == false
        ? [
            _c(
              "v-col",
              { staticClass: "ma-0 pa-0 pl-5 pr-5", attrs: { cols: "12" } },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "ma-0 pa-0",
                    attrs: { id: "data_box", cols: "12" },
                  },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pb-0 pl-5",
                                staticStyle: {
                                  "font-size": "0.9rem",
                                  "font-weight": "bold",
                                },
                                attrs: { cols: "12", align: "left" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.tsc("last30DaysVisitors")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pt-1 pl-5 pr-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "data_people_box",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { align: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.t("all")))]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "15,938" +
                                                      _vm.tsc("peopleCount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tsc("faceRecognition")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "13,658" +
                                                      _vm.tsc("peopleCount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 pb-3",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("BarChart", {
                                  attrs: {
                                    data: _vm.chartData,
                                    options: _vm.chartOptions,
                                    height: 150,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pb-0 pl-5",
                                staticStyle: {
                                  "font-size": "0.9rem",
                                  "font-weight": "bold",
                                },
                                attrs: { cols: "12", align: "left" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.tsc("last30DaysVisitors")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pt-1 pl-5 pr-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "data_people_box",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { align: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.t("man")))]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "7,503" +
                                                      _vm.tsc("peopleCount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.t("weman")))]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "8,435" +
                                                      _vm.tsc("peopleCount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 pb-3",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("BarChart", {
                                  attrs: {
                                    data: _vm.chartData,
                                    options: _vm.chartOptions,
                                    height: 150,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pb-0 pl-5",
                                staticStyle: {
                                  "font-size": "0.9rem",
                                  "font-weight": "bold",
                                },
                                attrs: { cols: "12", align: "left" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.tsc("last30DaysVisitors")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pt-1 pl-5 pr-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "data_people_box",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { align: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.tsg("new")))]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "7,503" +
                                                      _vm.tsc("peopleCount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.tsg("repeater2"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "8,435" +
                                                      _vm.tsc("peopleCount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 pb-3",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("BarChart", {
                                  attrs: {
                                    data: _vm.chartData,
                                    options: _vm.chartOptions,
                                    height: 150,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pb-0 pl-5",
                                staticStyle: {
                                  "font-size": "0.9rem",
                                  "font-weight": "bold",
                                },
                                attrs: { cols: "12", align: "left" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.tsc("last30DaysVisitors")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pt-1 pl-5 pr-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "data_people_box",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-1",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pl-2",
                                            attrs: {
                                              id: "data_sub_title",
                                              cols: "12",
                                              align: "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.t("sales")))]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pl-2",
                                            attrs: {
                                              id: "data_count",
                                              cols: "12",
                                              align: "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "12,591,543" + _vm.t("yen")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 pb-3",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("BarChart", {
                                  attrs: {
                                    data: _vm.chartData,
                                    options: _vm.chartOptions,
                                    height: 150,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "v-col",
              { staticClass: "ma-0 pa-0 pl-5 pr-5", attrs: { cols: "12" } },
              [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _c("v-skeleton-loader", {
                      attrs: {
                        boilerplate: false,
                        elevation: "0",
                        dark: "",
                        type: "image",
                        width: "100%",
                        height: "12rem",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0 mt-5", attrs: { cols: "12" } },
        [
          _c("v-divider", {
            staticClass: "ma-0 pa-0",
            attrs: { id: "middle_divider" },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }